module.exports = __webpack_public_path__ + "static/media/voyagetoasgard.81d076ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/voyagetoasgard.png
// module id = 1374
// module chunks = 1